import React from 'react';
import { useReceivingFeed } from 'hooks/useReceivingFeed';
import { sendMessage, updateSimulcastTemplate } from 'utils/webrtc/messages';
import { useAppSelector } from 'store/hooks';
import { selectRemoteStreamByMid } from 'features/streaming/streamingSlice';

export const useSimulcast = (mid: string) => {
  const videoStream = useAppSelector((state) => selectRemoteStreamByMid(state, mid));

  const { control } = useReceivingFeed();
  // Shown as what the media server is forwarding, which can sit below the requested pair.
  const substream = videoStream?.relayedSubstream ?? videoStream?.substream;
  const temporal = videoStream?.relayedTemporal ?? videoStream?.temporal;

  const changeSubstream = (_: React.MouseEvent<HTMLElement>, value: number) => {
    const feed = control.receiver?.plugin;

    if (feed) {
      sendMessage(feed.janusPlugin, updateSimulcastTemplate([{ mid, substream: value, temporal }]));
    }
  };

  const changeTemporal = (_: React.MouseEvent<HTMLElement>, value: number) => {
    const feed = control.receiver?.plugin;

    if (feed) {
      sendMessage(feed.janusPlugin, updateSimulcastTemplate([{ mid, temporal: value, substream }]));
    }
  };

  return {
    changeSubstream,
    changeTemporal,
    substream,
    temporal,
  };
};
